import { TabsContent, TabsData } from '../../../components/AboutAmwayBrands/types/propsTypes';
import type { AboutAmwayBrandsProps } from '../../../components/AboutAmwayBrands/AboutAmwayBrands';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';

const transformAboutAmwayBrands = (data: CMSTransformerDataType): AboutAmwayBrandsProps => {
  const tabsData: TabsData[] = [];
  const tabsContent: TabsContent[] = [];
  data &&
    data.categories?.forEach((item: CMSTransformerDataType) => {
      const mappedArr = item.sub_categories?.map((element: CMSTransformerDataType) => ({
        description: element.description,
        image: {
          images: element.image.images,
        },
        logo: {
          images: element.logo.images,
        },
        link: {
          text: element.link.text,
          url: element.link.url,
        },
      }));
      tabsData.push({
        title: item.header.text,
        id: item.header.url,
      });
      tabsContent.push({
        tabId: item.header.text,
        data: mappedArr,
      });
    });
  return {
    componentType: ComponentType.about_amway_brands,
    brandData: {
      tabsData: tabsData,
      tabsContent: tabsContent,
    },
    activeTabId: data.activeTabId,
    brandTitle: data.title,
    callBack: data.callBack,
  };
};

export default transformAboutAmwayBrands;
